import sizes, { SizeType } from './sizes/sizes';

const px = (value: number): string => `${value}px`;
// default version switched to static px because of external portals overriding
// `${(value / sizes.DEFAULT_FONT_SIZE).toString()}rem`;

const size = (type: SizeType): string => px(sizes[type]);

const styleUtils = {
  px,
  size
};

export default styleUtils;
